var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import Vue from 'vue';
import { DailyReportMutationTypes } from '@/types/daily-reports';
import dailyReportApiClient from '@/plugins/apis/v2/daily-report-api-client';
import contentApiClient from '@/plugins/apis/content-api-client';
import checkFirebaseAuthAndDoAction from '@/plugins/check-firebase-auth-and-do-action';
export var state = function () { return ({
    dailyReports: []
}); };
export var getters = {
    dailyReports: function (state) {
        return state.dailyReports;
    }
};
export var mutations = (_a = {},
    _a[DailyReportMutationTypes.INIT_STATE] = function (state, payload) {
        Object.assign(state, payload);
    },
    _a[DailyReportMutationTypes.FETCH_DAILY_REPORTS] = function (state, payload) {
        state.dailyReports = payload;
    },
    _a[DailyReportMutationTypes.DELETE_DAILY_REPORT] = function (state, payload) {
        var index = state.dailyReports.findIndex(function (rp) { return rp.id === payload; });
        if (index > -1) {
            Vue.delete(state.dailyReports, index);
        }
    },
    _a);
export var actions = {
    initState: function (_a) {
        var commit = _a.commit;
        commit(DailyReportMutationTypes.INIT_STATE, state());
    },
    fetchDailyReports: function (_a, payload) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var response, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, dailyReportApiClient.index(payload.projectId, payload.scheduleId, payload.smallProcessId)];
                    case 1:
                        response = _b.sent();
                        commit(DailyReportMutationTypes.FETCH_DAILY_REPORTS, response.data.daily_reports);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        console.log(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    },
    createDailyReport: function (_a, payload) {
        var dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var projectId, scheduleId, smallProcessId, otherParams, response, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        projectId = payload.projectId, scheduleId = payload.scheduleId, smallProcessId = payload.smallProcessId, otherParams = __rest(payload, ["projectId", "scheduleId", "smallProcessId"]);
                        return [4 /*yield*/, dailyReportApiClient.create(projectId, scheduleId, smallProcessId, otherParams || {}, payload.notice !== false)];
                    case 1:
                        response = _b.sent();
                        dispatch('fetchDailyReports', {
                            projectId: projectId,
                            scheduleId: scheduleId,
                            smallProcessId: smallProcessId
                        }, { root: false });
                        return [2 /*return*/, response.data.daily_report];
                    case 2:
                        e_2 = _b.sent();
                        console.log(e_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    },
    updateDailyReport: function (_a, payload) {
        var dispatch = _a.dispatch;
        return __awaiter(this, void 0, void 0, function () {
            var uploadPromises, contentPayload, contentPayload, _b, beforeContent, afterContent, response, e_3;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, , 4]);
                        uploadPromises = [];
                        if (payload.before_image_file) {
                            contentPayload = {
                                file: payload.before_image_file,
                                parent_id: payload.parent_content_id
                            };
                            uploadPromises.push(dispatch('uploadContent', contentPayload));
                        }
                        else {
                            uploadPromises.push(Promise.resolve(null));
                        }
                        if (payload.after_image_file) {
                            contentPayload = {
                                file: payload.after_image_file,
                                parent_id: payload.parent_content_id
                            };
                            uploadPromises.push(dispatch('uploadContent', contentPayload));
                        }
                        else {
                            uploadPromises.push(Promise.resolve(null));
                        }
                        return [4 /*yield*/, Promise.all(uploadPromises)];
                    case 1:
                        _b = _c.sent(), beforeContent = _b[0], afterContent = _b[1];
                        return [4 /*yield*/, dailyReportApiClient.update(__assign(__assign({}, payload), { before_image_id: beforeContent ? beforeContent.id : payload.before_image_id, after_image_id: afterContent ? afterContent.id : payload.after_image_id }))];
                    case 2:
                        response = _c.sent();
                        dispatch('fetchDailyReports', {
                            projectId: payload.projectId,
                            scheduleId: payload.scheduleId,
                            smallProcessId: payload.smallProcessId
                        }, { root: false });
                        return [2 /*return*/, response.data.daily_report];
                    case 3:
                        e_3 = _c.sent();
                        console.log(e_3);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    },
    uploadContent: function (_a, payload) {
        var rootGetters = _a.rootGetters;
        return __awaiter(this, void 0, void 0, function () {
            var res_1, content_1, e_4;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, contentApiClient.uploadContent(payload.parent_id, payload.file, {})];
                    case 1:
                        res_1 = _b.sent();
                        if (res_1.status === 200) {
                            content_1 = res_1.data.content;
                            setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                                var company;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, contentApiClient.uploadFileS3Request(res_1.data.meta, payload.file)];
                                        case 1:
                                            _a.sent();
                                            company = rootGetters['initial-setting/company'];
                                            checkFirebaseAuthAndDoAction(function () {
                                                contentApiClient.uploadFileFirebaseRequest(content_1);
                                            }, company.id);
                                            this.app.$gtag('event', Vue.prototype.$gaEvent.actionFileUpload);
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, 200);
                            return [2 /*return*/, content_1];
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        e_4 = _b.sent();
                        console.log(e_4);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    },
    deleteDailyReport: function (_a, payload) {
        var commit = _a.commit;
        return __awaiter(this, void 0, void 0, function () {
            var e_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, dailyReportApiClient.delete(payload.projectId, payload.scheduleId, payload.smallProcessId, payload.id)];
                    case 1:
                        _b.sent();
                        commit(DailyReportMutationTypes.DELETE_DAILY_REPORT, payload.id);
                        return [3 /*break*/, 3];
                    case 2:
                        e_5 = _b.sent();
                        console.log(e_5);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
};
